<script lang="ts">
const COOKIE_NAME = 'tutorial_configurator_document_popup'
</script>
<template>
    <div
        v-if="isVisible"
        class="max-md:hidden"
    >
        <div
            v-if="!configurator.isStarted()"
            class="fixed bottom-20 left-[20px] md:left-[220px] w-[353px] rounded-2xl overflow-hidden shadow-popup z-10"
        >
            <div class="bg-brand-gradient relative overflow-hidden h-[200px] p-4">
                <div class="flex justify-end">
                    <i
                        class="fa-light fa-xmark cursor-pointer z-10"
                        @click="hidePanel()"
                    ></i>
                </div>
                <img
                    src="/assets/configurator/document/popupanimation.gif"
                    class="w-full absolute -top-20 left-0"
                />
            </div>
            <div class="bg-branding-white p-6">
                <span class="text-xl">{{ $t('configurator.welcome') }} 🎉</span>
                <p class="text-base mb-6">{{ $t('configurator.document.intro') }} ⏱️</p>
                <div class="flex justify-between items-center">
                    <ConfiguratorUtilsProgressBarWithButton :configurator="configurator" />
                </div>
            </div>
        </div>
        <div
            v-else
            class="bg-branding-white rounded-full px-8 py-4 shadow-popup fixed bottom-20 left-[220px] flex items-center justify-between w-[429px] z-10"
        >
            <div>
                <div class="text-base font-bold mb-1">{{ $t('configurator.continue') }} {{ configurator.progressBar.completed }}/{{ configurator.progressBar.total }}</div>
                <div class="flex justify-between items-center gap-7">
                    <ConfiguratorUtilsProgressBarWithButton :configurator="configurator" />
                </div>
            </div>
            <i
                class="fa-light fa-xmark text-2xl cursor-pointer"
                @click="hidePanel()"
            ></i>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import Configurator from '~/app/common/models/Configurator';

    defineProps<{
        configurator: Configurator;
    }>();

    const isVisible = ref(false);

    // Cookie management
    
    const { isCookieSet, setCookie } = useCookieManager();

    onMounted(() => {
        isVisible.value = !isCookieSet(COOKIE_NAME);
    });

    const hidePanel = () => {
        // Hide box
        isVisible.value = false;

        // Set cookie with 1 day duration
        setCookie(COOKIE_NAME, 'oneDay');
    };
</script>
